/*
 * @Descripttion: 
 * @version: 
 * @Author: Yj
 * @Date: 2023-03-06 09:54:18
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2026-01-05 16:32:31
 */
const login = {
  "register_byaccount": "Register QriginQ Account",
  "has_byAccount": "",
  "go_login": "Login>",
  "mobileRegister": " Mobile phone",
  "emailRegister": "Email",
  "successTitle": "success",
  "account_register_suc": "The account information is successfully registered!",
  "return_login": "Back to login",
  "register_suc_text": "Registered successfully!",
  "register": "Register",
  "confirmPassword": "Confirm Password",
  "pwd_placeholder_text": "Password",
  "code_length6": "6-digit Verification Code",
  "phone_length11": "11-digit phone number",
  "email_address_suc": "Email Address",
  "get_code": "Send code",
  "enter_suc_code": "Please enter correct verify code.",
  "enter_pwd_two_not_match": "The two passwords do not match, please re-enter.",
  "enter_pwd_num_letter": "The password is a combination of digits or letters.",
  "enter_pwd_error":'Password does not meet specifications',
  "enter_pwd_length_p": "Please enter 8-32 characters.",
  "enter_pwd_p": "Please enter password.",
  "email_valid_err": "Enter a valid email address.",
  "phone_valid_err": "Phone number format is incorrect.",
  "getVerificationCodeSuccess":" Verification code sent successfully",
  "pwd_reset": "Reset Password",
  "pwd_phone_reset": "Reset Phone Number",
  "pwd_email_reset": "email reset",
  "pwd_reset_suc": "Password has been reset successfully.",
  "getCode": "Send Code",
  "resetSuccess": "Password reset successful",
  "new_confirmPassword": "Confirm Password",
  "resetpwd_btn_text": "RESET",
  "login_name_text": "Phone number/Email",
  "pwd": "Password",
  "view": "View",
  "VerificationCode":"Verification Code",
  "login_register": "Register",
  "login_forgot_pwd": "Forgot Password",
  "new_loginText": "SIGN IN",
  "enter_pwd_characters": "8-32 characters",
  "enter_pwd_following": "At least two of the following: uppercase letters, lowercase letters, numbers, special characters",
  "enter_pwd_contain_spaces": "Cannot contain spaces",
  "phoneEmptyTip": "请输入手机号",
  "register_tips1": "By clicking Register, you agree to these terms as well as the",
  "register_tips2": "User Agreement",
  "register_tips3": "and",
  "register_tips4": "Privacy Policy",
  login_bg_title: 'Log in to experience real quantum computing',
  login_bg_text: 'New users receive free computing time.',
  login_bg_bottom_line: 'Available after login',
  login_bg_bottom_Name1: 'Quantum Computer',
  login_bg_bottom_Text1: 'Free trial for new users upon sign-up',
  login_bg_bottom_Name2: 'Quantum SDK',
  login_bg_bottom_Text2: 'enhance programming efficiency',
  login_bg_bottom_Name3: 'Quantum computing applications',
  login_bg_bottom_Text3: 'Experience over 20 quantum applications',
  login_pwd_register: 'Register',
}
export default login